/** Custom jewelry (/custom-jewelry) — storefront labels and promo copy. */
import {
  BESPOKE_JEWELRY_TYPE_DEFAULTS,
  BESPOKE_OCCASION_DEFAULTS,
} from './bespokeFormOptionDefaults';

export const CUSTOM_JEWELRY_DEFAULTS = {
  enabled: true,
  show_on_shop: true,
  show_in_nav: true,
  show_in_footer: true,
  show_on_gift_finder: true,
  shop_button_label: 'Custom jewelry design',
  nav_label: 'Custom jewelry',
  card_eyebrow: 'Made to order',
  card_title: 'Design jewelry for your celebration',
  card_lead: 'Share your outfit photo — we match colours for haldi, mehendi, sangeet, or wedding.',
  card_cta: 'Start your design',
  hero_eyebrow: 'Bespoke studio',
  hero_title: 'Custom jewelry design',
  hero_lead:
    'Haldi, mehendi, sangeet, or wedding — upload your dress colours and tell us what you need. We reply with ideas and a quote.',
  hero_image: '',
  seo_title: 'Custom jewelry design | Saloni Designs',
  seo_description:
    'Share your outfit photo and occasion — we design handcrafted jardosi and festive jewelry made to order.',
  gift_finder_promo_title: 'Need something bespoke?',
  gift_finder_promo_lead:
    'We design jewelry to match your outfit for haldi, mehendi, sangeet, and wedding — upload a dress photo and get a quote.',
  gift_finder_promo_cta: 'Request custom design',
  occasions: BESPOKE_OCCASION_DEFAULTS.map((item) => ({ ...item })),
  jewelry_types: BESPOKE_JEWELRY_TYPE_DEFAULTS.map((item) => ({ ...item })),
};
